module.exports = __webpack_public_path__ + "img/guid_icon.55e17608.png";